// Module
var code = `<div class="fit gmap" data-bind="googlemap: {locations: locations, zoom: zoom, mapType: mapType, apiKey: apiKey, markerIcon: markerIcon, showReplyOffices: showReplyOffices, usePopupOverlay: usePopupOverlay, corporate: corporate}"></div>`;
// Exports
export default code;